import { GlobalBootstrap, BootstrapInstance } from '@/Types/bootstrap';
import { onBeforeUnmount, onMounted, ref, Ref } from 'vue';

export default function useBootstrapApi<TInstance extends BootstrapInstance>(
  builderCallback: (bootstrap: GlobalBootstrap) => TInstance, options?: { doNotDispose: boolean }): Ref<TInstance | null> {
  const instance: Ref<TInstance | null> = ref(null);

  onMounted(() => {
    if (!window.bootstrap) {
      console.error('Bootstrap is not found in window.bootstrap');
      return;
    }

    instance.value = builderCallback(window.bootstrap);
  });

  onBeforeUnmount(() => {
    if (!options?.doNotDispose) {
      instance.value?.dispose();
    }
  });

  return instance;
}